// Central date formatting utilities. UI displays DD/MM/YYYY across the ERP.
// Input strings are ISO from the backend (YYYY-MM-DD or full ISO datetime).

function _toDate(input) {
  if (!input) return null;
  // Bare YYYY-MM-DD → treat as local date to avoid TZ shifting the day.
  if (typeof input === "string" && /^\d{4}-\d{2}-\d{2}$/.test(input)) {
    const [y, m, d] = input.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  const d = input instanceof Date ? input : new Date(input);
  return isNaN(d.getTime()) ? null : d;
}

function _pad(n) { return String(n).padStart(2, "0"); }

export function formatDMY(input) {
  const d = _toDate(input);
  if (!d) return "";
  return `${_pad(d.getDate())}/${_pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

export function formatDMYTime(input) {
  const d = _toDate(input);
  if (!d) return "";
  return `${formatDMY(d)} ${_pad(d.getHours())}:${_pad(d.getMinutes())}`;
}
